import { createAction, props } from '@ngrx/store';
import { RankingTypes } from '../../models/rankings.models';

export const fetchRankingsList = createAction(
	'[StateRankings/API] Fetch Rankings List',
	props<{ category: string; rankingType: RankingTypes }>(),
);

export const updateRankingsList = createAction(
	'[StateUniversity/API] Update Rankings List',
	props<any>(),
);

export const loadStateRankingsFailure = createAction(
	'[StateRankings/API] Load StateRankings Failure',
	props<any>(),
);
